import { FrontendScriptDefinition } from "./frontend-script-definition.model";
import { FrontendScriptNode } from "./frontend-script-node.model";
import { FrontendScriptOutlineItem } from "./frontend-script-outline-item.model";

export class FrontendScriptsDefinition {
    scripts: FrontendScriptDefinition[] = [];
    nodes: FrontendScriptNode[] = [];
    globalOutlineItems: FrontendScriptOutlineItem[] = [];
 
    getNode(id: string): FrontendScriptNode {
        return this.nodes.find(n => n.id == id);
    }

    getOrAddNode(id: string, generateName: () => string, generateSortName: () => string): FrontendScriptNode {
        let node = this.getNode(id);
        if (node == null) {
            node = new FrontendScriptNode(id, generateName(), generateSortName());
            this.nodes.push(node);
        }
        return node;
    }

    calculate(): void {
        for (let script of this.scripts) {
            script.parentNodes = [];
            for (let parentId of script.parents) {
                let node = this.getNode(parentId);
                script.parentNodes.push(node ?? new FrontendScriptNode(parentId, parentId, parentId));
            }
        }
    }
}
